import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  LuiWidgetWrapperModule,
  LuiWizardV3Module,
  PerFormPrimengModule,
} from '@lbmx/per-form-primeng';
import { TranslocoModule } from '@ngneat/transloco';
import { CanDeactivateGuard } from '../reload/can-deactivate.guard';
import { WizardLoaderComponent } from './wizard-loader.component';

@NgModule({
  declarations: [WizardLoaderComponent],
  imports: [
    CommonModule,
    PerFormPrimengModule,
    LuiWizardV3Module,
    LuiWidgetWrapperModule,
    TranslocoModule,
  ],
  providers: [CanDeactivateGuard],
  exports: [WizardLoaderComponent],
})
export class WizardLoaderModule {}
